import { Amount, BusinessParticularities, Gravanz, Conditional, AgreeWith, Bonification, FreightPaid, GrassiPlants, Reduction, SiloBolsas, Accumulator, FinancialAdvance } from "@shared-logic/business-particularities";

export const RATE_TO_DEFINE = 'A_DEFINIR';

export let AMOUNT_VOID: Amount = {
    typeCoin: '--',
    quantity: -1
}

//_------------------------------------_\\

export let ACCUMULATOR_VOID: Accumulator = {
    isAccumulator: -1,
    typeAccumulator: -1
}

export let GRAVANZ_VOID: Gravanz = {
    isGravanz: -1,
    isOwnSensorization: -1,
    business: ' ',
    selectionStock: ' '
}


export let CONDITIONAL_VOID: Conditional = {
    selection: -1,
    strike: -1,
    position: ' '
}

export let FREIGHT_PAID_VOID: FreightPaid = {
    isFreightPaid: -1,
    isCustomerFreight: -1,
    amount: {
        ...AMOUNT_VOID,
        typeCoin: RATE_TO_DEFINE,
    },
    numberOfDays: -1,
    eventType: ''
}

export let GRASSI_PLANTS_VOID: GrassiPlants = {
    placeOfDelivery: -1,
    parity: AMOUNT_VOID,
    volatileWaste: {
        percentage: -1,
        productDescription: ' ',
    },
    commission: {
        isHoard: -1,
        percentage: -1,
    },
    freight: {
        amount: AMOUNT_VOID,
        description: ' ',
    },
    humidity: {
        isPortFee: -1,
        amount: AMOUNT_VOID, 	//(always)
        percentage: -1,	//(always)
        reductionPoint: -1, //(always)
        reductionAmount: -1 //('only in isPortFee:true')
    }
}

export let SILO_BOLSAS_VOID: SiloBolsas = {
    quantity: -1,
    brand: -1,
    size: -1,
}

export let BONIFICATION_VOID: Bonification = {
    typeBonification: -1,
    startDate: '--', 	//(only in 'Entrega anticipada')
    endDate: '--',	//(only in 'Entrega anticipada')
    placeOfDelivery: -1, //(only in 'Cambio de destino')
    amount: AMOUNT_VOID
}

export let REDUCTION_VOID: Reduction = {
    percentage: -1,
    amount: -1,
    typeCoin: "--", //AMOUNT_VOID
}

export let AGREE_WITH_VOID: AgreeWith = {
    comercialName: ' ',
    buyer: ' ',
    responsable: ' '
}

export let FINANCIAL_ADNAVANCE_VOID: FinancialAdvance = {
    amountRate: 0,
    percentagePayable: 0,
    percentageTypeToPay: 0,
    rate: 0,
    VAT: 0
}


export let BUSINESS_PARTICULARITIES_VOID: BusinessParticularities = {
    washOut: -1,
    gravanz: GRAVANZ_VOID,
    accumulator: ACCUMULATOR_VOID,
    conditional: CONDITIONAL_VOID,
    collectionClause: -1,
    respectVatException: -1,
    freightPaidByTheBuyer: FREIGHT_PAID_VOID,
    agreement: -1,
    deliveriesAtGrassiPlant: GRASSI_PLANTS_VOID,
    deliveryInSiloBolsas: SILO_BOLSAS_VOID,
    bonification: BONIFICATION_VOID,
    reduction: REDUCTION_VOID,
    laboratoryAgreement: -1,
    sealedToRetrieve: -1,
    toWithdraw: -1,
    agreedWith: AGREE_WITH_VOID,
    isAVC: -1,
    subdivisionSyngenta: -1,
    nroBilling: '',
    guaranteedPAF: false,
    financialAdvance: FINANCIAL_ADNAVANCE_VOID,
    campus: '',
    nutrienAgreement: false,
    isFasonContract: false,
    avBusiness: false
}

export let SEDE_AGRUPACION: any = {
    'CC': 'Casa Central',
    'CF': 'Capital Federal',
    'CO': 'Córdoba',
    'RC': 'Río Cuarto',
    'RE': 'Resistencia',
    'RO': 'Rosario',
    'SF': 'Santa Fe',
}

export let MARCA_SILO_BOLSAS: any = {
    1: 'Ipesa',
    2: 'Graner',
    3: 'Plastar',
    4: 'Thyssen',
}

export let TAMAIN_SILO_BOLSAS: any = {
    1: '9 x 60',
    2: '9 x 75',
    3: '9 x 100',
}

export let EVENTS_TYPES_OBJECT: { [key: string]: string } = {
    'APLICACION': 'Aplicación',
    'DESCARGA': 'Descarga',
    'PESIFICACION': 'Pesificación',
    'FACTURACION': 'Facturación'
}

export let EVENTS_TYPES_ARRAY: string[] = Object.keys(EVENTS_TYPES_OBJECT);
//['APLICACION', 'DESCARGA', 'PESIFICACIÓN', 'FACTURACION']

export const RATES_TYPES_OPTIONS = [
    { value: RATE_TO_DEFINE, name: 'A definir' },
    { value: '--', name: 'Definida' },
]





export const businessParticularities = {
    "-1": "--",
    0: "--",
    1: "Wash Out",
    2: "Gravanz",
    3: "Acumulador",
    4: "Condicional",
    5: "Cláusula cobranza",
    6: "Respeta excención de IVA",
    7: "Flete a cargo del comprador",
    8: "Convenio",
    9: "Entregas en planta Grassi",
    10: "Entrega en Silo Bolsas",
    11: "Bonificación",
    12: "Rebaja",
    13: "Convenio Laboratorio",
    14: "Sellado a recuperar",
    15: "A retirar",
    16: "Pactado con",
    17: "PAF Garantizado",
    18: "Anticipo financiero",
    21: 'Cramdown',
    22: 'Negocio AV',
}

export const particularities_soja_fabrica = [1, 2, 3, 4, 5, 6]

export const particularities_maiz_camara = [5, 6, 7];
export const particularities_maiz_grado2 = [5, 2, 8, 6, 7, 9, 10];

export const particularities_sorgo_camara = [5, 6, 7];
export const particularities_sorgo_grado2 = [5, 2, 8, 6, 7, 9, 10];

export const particularities_trigo_camara = [5, 11, 12, 6];
export const particularities_trigo_grado2 = [5, 11, 2, 6, 7, 8, 13];

export const particularities_cebada_cervecera_camara = [5, 14, 7, 15];

export const particularities_cebada_forrajera_camara = [5, 14];
export const particularities_cebada_forrajera_grado2 = [14];

export const BUSS_PART_CONST = {
    washOut: "Wash Out",
    gravanz: "Gravanz",
    accumulator: "Acumulador",
    conditional: "Condicional",
    collectionClause: "Cláusula cobranza",
    respectIVA: "Respeta excención de IVA",
    freightPaidByTheBuyer: "Flete a cargo del comprador",
    agreement: "Convenio",
    deliveriesAtGrassiPlant: "Entregas en planta Grassi",
    deliveryInSiloBolsas: "Entrega en Silo Bolsas",
    bonification: "Bonificación",
    reduction: "Rebaja",
    laboratoryAgreement: "Convenio Laboratorio",
    sealedToRetrieve: "Sellado a recuperar",
    toWithdraw: "A retirar",
    agreedWith: "Pactado con",
    financialAdvance: "Anticipo financiero",
    guaranteedPAF: "PAF Garantizado",
    nutrienAgreement: "Convenio Nutrien",
    contractFason: "Contrato Fasón",

    cramdown: 'Cramdown',
    avBusiness: 'Negocio AV',
}

const PRIORITIZED_BUSINESS_PARTICULARITIES = [
    BUSS_PART_CONST.washOut,
    BUSS_PART_CONST.cramdown,
];

export const BUSS_PART_FILTER_OPTIONS = [
    ...PRIORITIZED_BUSINESS_PARTICULARITIES,
    ...Object.values(BUSS_PART_CONST).filter(
        (value) => !PRIORITIZED_BUSINESS_PARTICULARITIES.includes(value)
    ),
];

export const BUSS_PART_YES_OR_NOT = [
    BUSS_PART_CONST.washOut,
    BUSS_PART_CONST.nutrienAgreement,
    BUSS_PART_CONST.collectionClause,
    BUSS_PART_CONST.respectIVA,
    BUSS_PART_CONST.agreement,
    BUSS_PART_CONST.toWithdraw,
    BUSS_PART_CONST.guaranteedPAF,
    BUSS_PART_CONST.contractFason,
    BUSS_PART_CONST.cramdown,
    BUSS_PART_CONST.avBusiness,
]

export const BUSS_PART_TAGS = {
    washOut: 'washOut',
    gravanz: 'gravanz',
    accumulator: 'accumulator',
    conditional: 'conditional',
    collectionClause: 'collectionClause',
    respectVatException: 'respectVatException',
    freightPaidByTheBuyer: 'freightPaidByTheBuyer',
    agreement: 'agreement',
    deliveriesAtGrassiPlant: 'deliveriesAtGrassiPlant',
    deliveryInSiloBolsas: 'deliveryInSiloBolsas',
    bonification: 'bonification',
    reduction: 'reduction',
    laboratoryAgreement: 'laboratoryAgreement',
    sealedToRetrieve: 'sealedToRetrieve',
    toWithdraw: 'toWithdraw',
    agreedWith: 'agreedWith',
    financialAdvance: 'financialAdvance',
    guaranteedPAF: 'guaranteedPAF',
    nutrienAgreement: 'nutrienAgreement',
    contractFason: 'isFasonContract',

    cramdown: 'cramdown',
    avBusiness: 'avBusiness',
}

export const BUSS_PART_NAME_TO_TAG: any = {
    "Wash Out": BUSS_PART_TAGS.washOut,
    "Gravanz": BUSS_PART_TAGS.gravanz,
    "Acumulador": BUSS_PART_TAGS.accumulator,
    "Condicional": BUSS_PART_TAGS.conditional,
    "Cláusula cobranza": BUSS_PART_TAGS.collectionClause,
    "Respeta excención de IVA": BUSS_PART_TAGS.respectVatException,
    "Flete a cargo del comprador": BUSS_PART_TAGS.freightPaidByTheBuyer,
    "Convenio": BUSS_PART_TAGS.agreement,
    "Entregas en planta Grassi": BUSS_PART_TAGS.deliveriesAtGrassiPlant,
    "Entrega en Silo Bolsas": BUSS_PART_TAGS.deliveryInSiloBolsas,
    "Bonificación": BUSS_PART_TAGS.bonification,
    "Rebaja": BUSS_PART_TAGS.reduction,
    "Convenio Laboratorio": BUSS_PART_TAGS.laboratoryAgreement,
    "Sellado a recuperar": BUSS_PART_TAGS.sealedToRetrieve,
    "A retirar": BUSS_PART_TAGS.toWithdraw,
    "Pactado con": BUSS_PART_TAGS.agreedWith,
    "Anticipo financiero": BUSS_PART_TAGS.financialAdvance,
    "PAF Garantizado": BUSS_PART_TAGS.guaranteedPAF,
    "Convenio Nutrien": BUSS_PART_TAGS.nutrienAgreement,
    "Contrato Fasón": BUSS_PART_TAGS.contractFason,

    "Cramdown": BUSS_PART_TAGS.cramdown,
    "Negocio AV": BUSS_PART_TAGS.avBusiness,
}